import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class LoginService {

    constructor() {
        this.httpClient = new HttpClient()

        this.url = "https://keycloak.sandooghmn.ir/realms/manager-fund/protocol/openid-connect/token"
        // this.url = "http://172.17.0.1:8442/realms/manager-fund/protocol/openid-connect/token"
    }


    sendSms(userName, password) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `presentation/managers/otp/sms`,
                {
                    "username": userName,
                    "password": password
                }
            ).then(resolve).catch(reject)
        })

    }

    loginUser(userName, password) {

        let formData = new URLSearchParams()
        formData.append("username", userName)
        formData.append("password", password)
        formData.append("client_id", this.httpClient.clientId)
        formData.append("client_secret", this.httpClient.clientSecret)
        formData.append("grant_type", "password")

        return new Promise((resolve, reject) => {

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(
                this.url,
                formData,
                config)
                .then(resolve).catch(reject)


        })

    }

    getUserTokenByRefreshToken(refreshToken) {

        let formData = new URLSearchParams()
        formData.append("refresh_token", refreshToken)
        formData.append("client_id", this.httpClient.clientId)
        formData.append("client_secret", this.httpClient.clientSecret)
        formData.append("grant_type", "refresh_token")

        return new Promise((resolve, reject) => {

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(
                this.url,
                formData,
                config)
                .then(response => {
                    resolve(response)
                }).catch(reason => {
                reject(reason)
            })


        })
    }

    sendOtpSms(nationalCode, phoneNumber) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                "presentation/otp/sms",
                {
                    "phoneNumber": phoneNumber,
                    "nationalCode": nationalCode,
                    "otpKind": "MANAGER"
                }
            ).then(resolve).catch(reject)
        })
    }

    resetPassword(nationalCode, phoneNumber, confirmCode, newPassword) {
        let formData = new URLSearchParams()
        formData.append("nationalCode", nationalCode)
        formData.append("phoneNumber", phoneNumber)
        formData.append("otp", confirmCode)
        formData.append("newPassword", newPassword.password)


        return new Promise((resolve, reject) => {
            this.httpClient.post(
                "presentation/managers/password/reset",
                formData
            ).then(resolve).catch(reject)
        })
    }
}